var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Resizable as ResizableParent } from "react-resizable";
var Resizable = function (props) {
    var _a, _b;
    var onResize = props.onResize, onResizeStop = props.onResizeStop, onResizeStart = props.onResizeStart, width = props.width, restProps = __rest(props, ["onResize", "onResizeStop", "onResizeStart", "width"]);
    if (!width) {
        return React.createElement("th", __assign({}, restProps));
    }
    var isNoLeftBorder = (_a = props.className) === null || _a === void 0 ? void 0 : _a.includes("no-left-border");
    var isNoRightBorder = (_b = props.className) === null || _b === void 0 ? void 0 : _b.includes("no-right-border");
    return (React.createElement(ResizableParent, { width: width, height: 0, onResizeStart: onResizeStart, onResize: onResize, onResizeStop: onResizeStop, draggableOpts: { enableUserSelectHack: false } },
        React.createElement("th", __assign({}, restProps, { onClick: function (e) {
                try {
                    !e.target.className.includes('react-resizable') && props.onClick(e);
                }
                catch (e) { }
            }, style: __assign(__assign(__assign({}, restProps.style), isNoLeftBorder ? { borderLeft: "none" } : {}), isNoRightBorder ? { borderRight: "none" } : {}) }))));
};
export default Resizable;
//# sourceMappingURL=resizable.js.map